import { Stack, Text, View, styled } from 'tamagui';

export let PaginationContiner = styled(Stack, {
  pos: 'absolute',
  b: 130,
  fd: 'row',
  w: '100%',
  ai: 'center',
  jc: 'center',
});
